/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */
import { Token } from '@lumino/coreutils';
/**
 * The launcher token.
 */
export const ILauncher = new Token('@jupyterlab/launcher:ILauncher', `A service for the application activity launcher.
  Use this to add your extension activities to the launcher panel.`);
//# sourceMappingURL=tokens.js.map